import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Animations {
    constructor() {
        this.initScrollAnimations();
    }

    initScrollAnimations() {
        const header = document.querySelector(".header");
        const break_element = document.querySelector(".js-header-break");

        if (header && break_element) {
            ScrollTrigger.create({
                trigger: break_element,
                start: "top top",
                end: "+=1",
                onEnter: () => header.classList.add("header--scrolled"),
                onLeaveBack: () => header.classList.remove("header--scrolled"),
            });
        }
    }
}
